import PosCartActions from '../../../actions/PosCartActions';
import CartDiscounts from '../cart/CartDiscounts.react';

class Discount extends React.Component {

    constructor(props) {
        super(props);
        
        this.state = {
            discountCode: ''
        };

        this.apply = this.apply.bind(this);
    }

    componentDidMount() {
    }

    apply() {
        if (this.state.discountCode && this.state.discountCode.length > 0) {
            PosCartActions.applyDiscountByCode(this.props.guest, this.state.discountCode);
        }
    }

    render() {
        var self                 = this;
        // var page                 = this.props.page;
        var guest                = this.props.guest;
        var cart                 = this.props.cart;
        var appliedLoyaltyPoints = this.props.appliedLoyaltyPoints;
        var appliedDiscounts     = this.props.appliedDiscounts;
        var allotment            = this.props.allotment;

        // group discounts
        var discounts = [];
        for (var i=0; i<appliedDiscounts.length; i++) {
            var match = false;

            for (var j=0; j<discounts.length; j++) {
                if (discounts[j].DiscountId === appliedDiscounts[i].DiscountId)
                    match = j;
            }

            if (match === false) {
                discounts.push({
                    DiscountId     : appliedDiscounts[i].DiscountId,
                    DiscountReason : appliedDiscounts[i].DiscountReason,
                    DiscountAmt    : appliedDiscounts[i].DiscountAmt,
                    items          : [appliedDiscounts[i]]
                });
            } else {
                discounts[match].items.push(appliedDiscounts[i]);
                discounts[match].DiscountAmt += appliedDiscounts[i].DiscountAmt
            }
        }

        return (
            <div className='pos-sidebar__content'>
                <div class="input-group p-3">
                    <input type="text" class="form-control btn-light" placeholder="Discount Code" aria-label="Discount Code"
                        value={this.state.discountCode}
                        onChange={(e) => { this.setState({ discountCode : e.target.value }); }}
                    />
                    <div class="input-group-append">
                        <button class="btn btn-outline-primary" type="button"
                            onClick={this.apply}
                            disabled={!this.state.discountCode || this.state.discountCode.length <= 0}
                        >Apply</button>
                    </div>
                </div>

                <div className='pos-sidebar__title'>
                    Applied Discounts
                </div>

                { discounts.map((item, i) => {
                    return (
                        <CartDiscounts
                            i={i}
                            item={item}
                            guest={guest}
                            key={'discount_'+item.DiscountReason+i} />
                    );
                })}

            </div>
        );
    }
}

export default Discount;


/*


                            { discounts.map((item, i) => {
                                return (
                                    <CartDiscounts
                                        i={i}
                                        item={item}
                                        guest={guest}
                                        key={'discount_'+item.DiscountReason+i} />
                                );
                            })}


*/


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/sidebar/Discount.react.jsx